export default [
    {
        path: '/teacherPositions',
        name: 'teacherPositions',
        component: () => import ('./pages/Index')
    },
]